export const GET_JOBS = "GET_JOBS"
export const GET_JOB = "GET_JOB"
export const FILTER_JOB = "FILTER_JOB"
export const DELETE_JOB = "DELETE_JOB"